import '@vant/touch-emulator'
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'

import * as echarts from "echarts"

import store from './store'; //引入Vuex

import FloatTools from './components/FloatTools'
import IframePopup from './components/IframePopup'
import PageTop from './components/PageTop'

import Site from './assets/js/site.js'

import md5 from 'js-md5'


import {
  ActionSheet,
  Area,
  Button,
  Calendar,
  Card,
  Cell, CellGroup,
  Checkbox, CheckboxGroup,
  Collapse, CollapseItem,
  DatetimePicker,
  Dialog,
  DropdownItem,
  DropdownMenu,
  Field,
  Form,
  Grid, GridItem,
  Icon,
  Image,
  Lazyload,
  List,
  Loading,
  NavBar,
  Overlay,
  Picker,
  Popover,
  Popup,
  Radio, RadioGroup,
  Rate,
  ShareSheet,
  Skeleton,
  Stepper,
  Sticky,
  SubmitBar,
  Swipe, SwipeItem,
  Switch,
  Tab, Tabs,
  Tag,
  Toast,
  Uploader
} from 'vant'

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Switch)
  .use(Uploader)
  .use(Rate)
  .use(Picker)
  .use(Loading)
  .use(Area)
  .use(DatetimePicker)
  .use(Skeleton)
  .use(Overlay)
  .use(Popover)
  .use(ShareSheet);

Vue.use(Site);

Vue.use(VueAxios, axios);

Vue.use(FloatTools);
Vue.use(PageTop);
Vue.use(IframePopup);
//======= 注册自定义组件
Vue.component('FloatTools', FloatTools);
Vue.component('PageTop', PageTop);
Vue.component('IframePopup', IframePopup);
import loadingService from '@/components/LoadingService/index.js'
import APIloading from '@/components/LoadingService/APIloading.vue'
Vue.component('APIloading', APIloading)
import NoData from '@/components/NoData.vue'
Vue.component('NoData', NoData)
Vue.prototype.$loadingService = loadingService
Vue.prototype.qs = qs;

Vue.prototype.$echarts = echarts;

Vue.prototype.$md5 = md5;

//======= 路由守卫
router.beforeEach((to, from, next) => {

  //电动车环境中，用某既定页面替代首页
  if( to.path === '/' && store.state.browser.giantevapp ) {
    //router.replace({ path: '/land/' + store.state.giantEvIndexId});
    location.replace('/#/land/' + store.state.giantEvIndexId);
    setTimeout(function(){
      location.reload();
    }, 500);
    return false;
  }

  //路由发生变化修改页面title
  if (to.meta.title) {
    if(to.path === '/') {
      document.title = 'QRcode';
    } else {
      document.title = to.meta.title + ' - QRcode';
    }
  }
/*
  //分享信息
  let metaList = document.getElementsByTagName('meta');
  for (var i = 0; i < metaList.length; i++) {
    if (metaList[i].getAttribute("name") == "shareImg") {
      metaList[i].content = "./static/img/share_logo.png";
    }
    if (metaList[i].getAttribute("name") == "shareTitle") {
      metaList[i].content = document.title;
    }
    if (metaList[i].getAttribute("name") == "shareDesc") {
      metaList[i].content = document.title;
    }
    if (metaList[i].getAttribute("name") == "shareLink") {
      let tmpMeta = metaList[i];
      setTimeout(function(){
        tmpMeta.content = location.href;
      }, 100);
    }
  }
*/

  //获取到已登录的用户信息
  let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));

  if( loginuser_data && loginuser_data.sessionkey ){
    store.commit('updateLoginUser', loginuser_data);
  } else {
    //判断当前页是否需要登录
    if( to.meta.requireLogin ){
      //console.log(location.href);
      router.replace({ path: '/login', query: { redirect: location.href }});
      //router.replace({ path: '/login', query: { redirect: to.fullPath }});
      //router.push({ path: '/login', query: { redirect: to.fullPath }});
    }
  }
  next();
});

Vue.config.productionTip = false;

const _Vue = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
}).$mount("#app");

export default _Vue;



// WEBPACK FOOTER //
// ./src/main.js